// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import axios from "../../utils/BasicAuthAPI";
import { Tabs, Radio, Row, Col } from "antd";
import LineGraph from "./Common/Graph/LineGraph";
import BasicBarGraph from "./Common/Graph/BasicBarGraph";
import ColoredBarGraph from "./Common/Graph/ColoredBarGraph";
import GaugeGraph from "./Common/Graph/GaugeGraph";
import "./managerDashboard.css";
import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
 import digitalFactoryLogo from '../../images/DigitalFactory.png';
import { Link } from "react-router-dom";
import StablePrime from "../Tables/StablePrime";

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class TrendDataDynamic extends React.Component {
    state = {
        mainData: null,
        dailyTrend: null,
        hourlyTrend: null,
        linePref: null,
        mtdData: null,
        loading: true,
        loginError: false,
        selectedTab: null,
        lid: 'all',
        tabsData: null,
        selectedMnt: 'all',
        table: null,
        dataLoading: false
    };

    constructor(props) {
        super(props);
        this._isMounted = false;
    }

    onChange = (e) => {
        
        const st = this;
        this.setState({
            ...this.state,
            selectedTab: e.target.value,
            loading: true,
        });
        this.fetchTrendData(e.target.value);
    };

    changeLid = (lid) => {
        let val = this.state.lid === 'all' ? lid : this.state.lid === lid ? "all" : lid;
        this.setState({ ...this.state, lid: val, dataLoading: true });
        this.fetchTrendData(this.state.selectedTab, val, this.state.selectedMnt);
    };


    clearCache() {
        
        var listCacheKeys = ["DefectIdame", "DefectLogTypes", "machine", "bom", "BomXXX", "Employee_idame"];
        for (var i = 0; i < listCacheKeys.length; i++) {
            var cacheItem = listCacheKeys[i];
            
            window.localStorage.removeItem(cacheItem);
        }
    };

    getTabs() {
        liracrypt.get('/dashboardtabsdynamicparam', {})
            .then(response => {
                let __tabs = response.data.data;
                this.setState({
                    tabsData: __tabs,
                    selectedTab: __tabs?.find(x => x.isDefault === true)?.subTyp
                }, () => {
                    if (this._isMounted && this.state.selectedTab) {
                        this.fetchTrendData(this.state.selectedTab);
                    }
                });
            }).catch(err => {
                console.log(err);
            });
    }

    componentDidMount() {
        
        this.clearCache();
        // this.updateMdictVersion();
        this.props.setPageHeader("Dashboard");
        this._isMounted = true;
        this.getTabs();
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.loginError = false;
    }

    fetchTrendData = (selectedTab, lid = "all", mnt = "all") => {
        liracrypt
            .get("/mdash/trenddatadynamic", {
                lid,
                mnt,
                typ: "MainGraph",
                subTyp: selectedTab,
            })
            .then(({ data }) => {
                const newData = { ...data };
                let newDataConfig = {};
                newDataConfig["dailyTrend"] = newData["data"]["trend_D"].map(x => {
                    return { _id: x._id, lastMonth: x.tgt, mtd: x.act }
                });
                newDataConfig["tableData"] = newData["data"]["tableData"];
                newDataConfig["legend"] = newData["data"]["legend"];
                newDataConfig["title"] = newData["data"]["title"];
                newDataConfig["hourlyTrend"] = newData["data"]["trend_H"];
                newDataConfig["linePref"] = newData["data"]["linePerf"];
                newDataConfig["mtdData"] = newData["data"]["trend_M"].map(x => {
                    return { _id: x._id, val: x.val, name: x.name, color: "#fd9644" }
                });
                delete newData["data"]["trend_D"];
                delete newData["data"]["trend_H"];
                delete newData["data"]["linePerf"];
                newDataConfig["mainData"] = { ...newData };
                this._isMounted &&
                    this.setState({ ...this.state, ...newDataConfig, loading: false, dataLoading: false }, () => {
                        
                    });
            })
            .catch((error) => {
                // message.error('ERROR: Unable to save!', 4);
                console.log(error);
                if (error.response !== undefined) {
                    if (error.response.status !== 401) {
                        ApiErrorComp(error.response.status);
                    } else {
                        this.setState({
                            ...this.state,
                            loginError: true,
                        });
                    }
                }
            });
    };

    changeBasicGraph(data) {
        let val = this.state.selectedMnt === 'all' ? data._id : this.state.selectedMnt === data._id ? 'all' : data._id;
        this.setState({
            selectedMnt: val,
            dataLoading: true
        });
        this.fetchTrendData(this.state.selectedTab, this.state.lid, val)
    }

    render() {
        if (this.state.mainData) {
            return (
                <>
                    <SessionError visible={this.state.loginError} />
                    <div>
                        <div style={{
                            display: 'inline-flex',
                            alignContent: 'center',
                            alignItems: 'center',
                            justifyContent: 'space-around',
                            width: '100%'
                        }}>
                            <div className="logo" style={{
                                margingLeft: 14,
                                padding: 10
                            }}>
                                <img src={digitalFactoryLogo} alt="sarex" width="150" />
                            </div>
                            <Radio.Group
                                className="managerTabs"
                                value={"small"}
                                onChange={this.onChange}
                            >
                                {
                                    this.state.tabsData && (
                                        this.state.tabsData.map((tab, index) => (
                                            <Radio.Button
                                                key={index}
                                                className={tab?.label?.toLowerCase()}
                                                style={{
                                                    backgroundColor: "#262626",
                                                    color: tab?.color,
                                                    textAlign: "center",
                                                    fontSize: "17px",
                                                    fontWeight: 600,
                                                    boxShadow: boxShadow,
                                                    maxWidth: "200px",
                                                }}
                                                value={tab?.subTyp}
                                            >
                                                {tab?.label}
                                            </Radio.Button>
                                        ))
                                    )
                                }
                            </Radio.Group>
                            <div style={{
                                boxShadow: 'rgb(30 30 30) 5px 5px 10px, rgb(46 46 46) -5px -5px 10px',
                                borderRadius: 10,
                                padding: 10,
                                marginRight: 25,
                                marginBottom: 13
                            }}>
                                <Link to="/dashboard">
                                    <HomeOutlined style={{
                                        fontSize: 25
                                    }} />
                                </Link>

                            </div>
                        </div>
                        {this.state.loading === false ? (
                            <div
                                style={
                                    {
                                        // border: "2px solid " + this.state.mainData.data.color,
                                        // borderRadius: "10px",
                                        // border: "2px solid #3b3b3b",
                                        // borderTopColor: this.state.mainData.data.color,
                                        // borderTopWidth: "3px",
                                    }
                                }
                            >
                                <Row>
                                    <Col span={4}>

                                        <div
                                            style={{
                                                display: "inline-block",
                                                margin: "10px",
                                                backgroundColor: this.state.mainData.data.color,

                                                padding: "30px 0px 30px 0px",
                                                width: "100%",
                                                verticalAlign: "middle",
                                                textAlign: 'center',
                                                boxShadow:
                                                    "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                                                borderRadius: "10px",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    color: "#262626",
                                                    fontSize: "30px",
                                                    fontWeight: 600,
                                                }}
                                            >
                                                {`${this.state.mainData.data.title.tabTitle} `}
                                            </span>
                                        </div>



                                        {this.state.mainData && this.state.mainData.data.icon ? (
                                            <div
                                                style={{
                                                    margin: "10px",
                                                    padding: "10px",
                                                    boxShadow:
                                                        "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                                                    borderRadius: "10px",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "inline-block",
                                                        paddingLeft: "45px",
                                                        paddingTop: "25px",
                                                        paddingBottom: "45px",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <img
                                                        src={this.state.mainData.data.icon}
                                                        alt={this.state.mainData.data.icon}
                                                        height="100px"
                                                    />
                                                </div>
                                                {/* <div
                                                    style={{
                                                        display: "inline-block",
                                                        padding: "30px",
                                                        width: "60%",
                                                        verticalAlign: "middle",
                                                    }}
                                                >
                                                    
                                                </div> */}
                                                <br></br>

                                                <span
                                                        style={{

                                                            color: "#b1b0b5",
                                                            paddingTop: "5px",
                                                            paddingLeft: "40px",
                                                            textAlign: 'center',
                                                            fontSize:
                                                                this.state.selectedTab == "DT" ? "30px" : "30px",
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {`${this.state.mainData.data.mainValPerc} `}
                                                    </span>





                                            </div>
                                        ) : null}
                                        {/* {this.state.mainData &&
                                            this.state.mainData.data.mainValPerc &&
                                            this.state.selectedTab != "DT" ? (
                                            <GaugeGraph
                                                divId={"MainValPerc"}
                                                barColor={this.state.mainData.data.color}
                                                labelText={this.state.mainData.data.mainValPerc}
                                                labelColor={this.state.mainData.data.color}
                                            />
                                        ) : null} */}
                                    </Col>
                                    <Col span={8}>
                                        {this.state.mtdData ? (
                                            <BasicBarGraph
                                                divId={"mtdData"}
                                                title={this.state.title.trend_M || "Monthly Performance"}
                                                themeColor={this.state.mainData.data.color}
                                                colorMtd={this.state.mainData.data.colorMtd}
                                                barkey={"val"}
                                                category={"_id"}
                                                data={this.state.mtdData}
                                                onChange={(data) => this.changeBasicGraph(data)}
                                            />
                                        ) : null}
                                    </Col>
                                    <Col span={12}>
                                        {
                                            this.state.dataLoading ? (
                                                <div style={{
                                                    height: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}>
                                                    <Spin indicator={antIcon} />
                                                </div>
                                            ) :
                                                this.state.dailyTrend ? (
                                                    <LineGraph
                                                        divId={"linegraph01"}
                                                        title={this.state.title.trend_D || "Daily Performance"}
                                                        legend1={this.state.legend.trend_D.tgt}
                                                        legend2={this.state.legend.trend_D.act}
                                                        lineTwoValue={"lastMonth"}
                                                        lineTwoColor={"#e91e63"}
                                                        lineOneColor={this.state.mainData.data.colorMtd}
                                                        lineOneValue={"mtd"}
                                                        category={"_id"}
                                                        data={this.state.dailyTrend}
                                                    />
                                                ) : null
                                        }
                                    </Col>
                                </Row>
                                <Row className="outer_table">
                                    <Col span={12}>
                                        {this.state.linePref ? (
                                            <ColoredBarGraph
                                                divId={"linePref"}
                                                title={this.state.title.linePerf}
                                                barColor={this.state.mainData.data.color}
                                                barkey={"val"}
                                                category={"_id"}
                                                data={this.state.linePref}
                                                changeLid={this.changeLid}
                                            />
                                        ) : null}
                                    </Col>
                                    <Col className="inner_data" span={12}>

                                        {this.state.dataLoading ? (
                                            <div style={{
                                                height: '100%',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}>
                                                <Spin indicator={antIcon} />
                                            </div>
                                        ) :
                                            this.state.tableData ? (
                                                <div style={{ marginTop: "0px" }}>
                                                    <StablePrime
                                                        url=""
                                                        response={this.state.tableData}
                                                        identity=""
                                                    />
                                                </div>
                                            ) : null
                                        }
                                    </Col>
                                </Row>
                            </div>
                        ) : (
                            <div className="Loading" style={{ minHeight: "100vh" }}>
                                <Spin indicator={antIcon} />
                            </div>
                        )}
                    </div>
                </>
            );
        } else {
            return (
                <>
                    {" "}
                    <SessionError visible={this.state.loginError} />
                    <div className="contentEmpty"></div>
                </>
            );
        }
    }
}

export default TrendDataDynamic;
